(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function initializeContactValidation(root) {
    root.querySelectorAll('.contact-form__form').forEach((form) => {
      if (form.dataset.validationReady === 'true') return;

      const summary = form.querySelector('[data-contact-errors]');
      const list = summary?.querySelector('ul');
      const fields = Array.from(form.querySelectorAll('[data-required-message]'));
      if (!summary || !list || fields.length === 0) return;

      form.dataset.validationReady = 'true';
      let validationQueued = false;

      const getErrors = () => fields.flatMap((field) => {
        if (!field.value.trim()) return [{ field, message: field.dataset.requiredMessage }];
        if (!field.validity.valid) return [{ field, message: field.dataset.invalidMessage || field.validationMessage }];
        return [];
      });

      const renderErrors = (errors, reveal = false) => {
        list.replaceChildren();

        fields.forEach((field) => {
          if (field.dataset.contactClientError !== 'true') return;
          const descriptions = (field.getAttribute('aria-describedby') || '').split(' ').filter((id) => id && id !== `${field.id}-required-error`);
          field.removeAttribute('aria-invalid');
          if (descriptions.length) field.setAttribute('aria-describedby', descriptions.join(' '));
          else field.removeAttribute('aria-describedby');
          delete field.dataset.contactClientError;
        });

        errors.forEach(({ field, message }) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          item.id = `${field.id}-required-error`;
          link.href = `#${field.id}`;
          link.textContent = message;
          item.append(link);
          list.append(item);
          field.setAttribute('aria-invalid', 'true');
          const descriptions = new Set((field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
          descriptions.add(item.id);
          field.setAttribute('aria-describedby', Array.from(descriptions).join(' '));
          field.dataset.contactClientError = 'true';
        });

        summary.hidden = errors.length === 0;
        if (reveal && errors.length) {
          summary.focus({ preventScroll: true });
          const pageWrapper = form.closest('.page-wrapper');
          const scrollRoot = pageWrapper && ['auto', 'scroll'].includes(window.getComputedStyle(pageWrapper).overflowY) ? pageWrapper : window;
          scrollRoot.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      };

      form.addEventListener('invalid', (event) => {
        if (!fields.includes(event.target)) return;
        event.preventDefault();
        if (validationQueued) return;
        validationQueued = true;
        queueMicrotask(() => {
          validationQueued = false;
          renderErrors(getErrors(), true);
        });
      }, true);

      form.addEventListener('submit', (event) => {
        const errors = getErrors();
        if (errors.length) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        renderErrors(errors, errors.length > 0);
      }, true);

      form.addEventListener('input', () => {
        if (!summary.hidden) renderErrors(getErrors());
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeContactValidation(document), { once: true });
  } else {
    initializeContactValidation(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeContactValidation(event.target));
  } catch(e) { console.error(e); }
})();

})();
